<!--=================================
=            PAGINATIONS            =
==================================-->

<template>
  <!-- PAGINATIONS -->
  <v-container >
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Paginations</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <!-- PAGINATIONS -->
   
      <!-- PAGINATIONS -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Long</div>
          <div slot="card-body">
            <div class="text-center">
              <v-container>
                <v-row justify="center">
                       <v-col cols="12" md="3" sm="12">
                    <v-container class="max-width">
                      <v-pagination v-model="page" class="my-4" :length="15"></v-pagination>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- PAGINATIONS -->
   


      <!-- PAGINATIONS -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Circle</div>
          <div slot="card-body">
            <div class="text-center">
              <v-pagination v-model="page" :length="4" circle></v-pagination>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- PAGINATIONS -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <!-- PAGINATIONS -->
          <div slot="card-header">Icons</div>
          <div slot="card-body">
            <div class="text-center">
              <v-pagination v-model="page" :length="4" prev-icon="mdi-menu-left" next-icon="mdi-menu-right">
              </v-pagination>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- PAGINATIONS -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Disabled</div>
          <div slot="card-body">
            <div class="text-center">
              <v-pagination :length="3" disabled></v-pagination>
            </div>
          </div>
        </base-card>
      </v-col>


    </v-row>

  </v-container>

</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
  export default {
    components: {
      BaseCard,BaseHeader
    },
    data() {
      return {
        circle: false,
        disabled: false,
        length: 10,
        page: 1,
        nextIcon: "navigate_next",
        nextIcons: ["mdi-chevron-right", "mdi-arrow-right", "mdi-menu-right"],
        prevIcon: "navigate_before",
        prevIcons: ["mdi-chevron-left", "mdi-arrow-left", "mdi-menu-left"],

        totalVisible: 10
      };
    }
  };
</script>

<!--====  End of PAGINATIONS  ====-->
